<template lang="pug">
//- Este componente no renderiza nada en el DOM
div(style="display: none;")
</template>

<script>
import {
  OptionsMixin,
  ControlMixin,
  propsBinder,
  optionsMerger
} from 'vue2-leaflet';
import L from 'leaflet';
import 'leaflet-measure';
import 'leaflet-measure/dist/leaflet-measure.css';

export default {
  name: 'MeasureControl',

  mixins: [
    ControlMixin,
    OptionsMixin,
  ],

  props: {
    options: {
      type: Object,
      default: () => ({
        position: 'topleft',
        // primaryLengthUnit: 'meters',
        // secondaryLengthUnit: 'kilometers',
        // primaryAreaUnit: 'sqmeters',
        // secondaryAreaUnit: 'hectares',
      }),
    },
  },

  mounted() {
    const options = optionsMerger({
      ...this.controlOptions,
      options: this.options,
    }, this);
    // El mapa de vue2-leaflet está disponible en el padre (LMap)
    this.$nextTick(() => {
      const map = this.$parent.mapObject;
      // parche para evitar recentrado
      if (L.Control.Measure && L.Control.Measure.include) {
        L.Control.Measure.include({
          // eslint-disable-next-line
          _centerCaptureMarker: function () {
            // eslint-disable-next-line
            return;
          },
          // eslint-disable-next-line
          _captureMarker: function () {
            if (!this._map) return;
            if (!this._captureMarkerInstance) {
              this._captureMarkerInstance = L.marker(this._map.getCenter(), {
                opacity: 0,
                clickable: false,
                keyboard: false,
              });
            }
            return this._captureMarkerInstance;
          }
        });
      }
      this.control = L.control.measure(options);
      propsBinder(this, this.control, this.$options.props);
      this.$parent.mapObject.addControl(this.control);
      // 👇 aquí escuchas los eventos del plugin
      map.on('measurestart', this.onMeasureStart);
      map.on('measurefinish', this.onMeasureFinish);

      // 👇 Evento de fullscreenchange
      map.on('fullscreenchange', () => {
        if (this.control) {
          map.removeControl(this.control);
          this.control = L.control.measure(this.options).addTo(map);
        }
      });
    });
  },

  beforeDestroy() {
    const map = this.$parent.mapObject;
    if (this.control) {
      this.$parent.mapObject.removeControl(this.control);
    }
    // Limpia los listeners
    map.off('measurestart', this.onMeasureStart);
    map.off('measurefinish', this.onMeasureFinish);
  },

  methods: {
    onMeasureStart() {
      const map = this.$parent.mapObject;
      if (map.keyboard) map.keyboard.disable();
      const originalPanTo = map.panTo;
      map.panTo = function f() {
        map.panTo = originalPanTo; // restaurar inmediatamente
        return map;
      };
    },
    onMeasureFinish() {
      if (this.$parent.mapObject.keyboard) this.$parent.mapObject.keyboard.enable();
    },
  }
};
</script>

<style scoped>
/* Puedes sobrescribir estilos del control aquí si lo necesitas */
</style>
